export default __webpack_public_path__ + "img/54cb39904dea021724a113d29e39653c.svg";